export default "__VITE_ASSET__aYymyFoY__"